import { brandRgb, startFallingLayer } from './falling_layer';

var snow = null;

function makeFlake(width, height) {
  var crystal = Math.random() < 0.18;
  return {
    x: Math.random() * width,
    y: Math.random() * height,
    r: crystal ? 4 + Math.random() * 3.5 : 1.2 + Math.random() * 2.3,
    crystal: crystal,
    alpha: crystal ? 0.7 + Math.random() * 0.25 : 0.55 + Math.random() * 0.35,
    speed: 14 + Math.random() * 26,            // px por segundo
    sway: 10 + Math.random() * 22,             // amplitude do balanço
    phase: Math.random() * Math.PI * 2,
    spin: (Math.random() - 0.5) * 0.6,
    angle: Math.random() * Math.PI
  };
}

// Cada floco é desenhado uma vez numa imagem pequena e, a cada quadro, só essa imagem é copiada:
// redesenhar o brilho (shadowBlur) de 70 flocos a 60 fps pesava a página inteira
var SPRITE_SCALE = 2;

function flakeSprite(f, rgb) {
  var edge = 'rgba(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ',' + (f.alpha * 0.8) + ')';
  var white = 'rgba(255,255,255,' + f.alpha + ')';
  var pad = f.crystal ? 2 : f.r * 1.6 + 2;
  var size = Math.ceil((f.r + pad) * 2);
  var sprite = document.createElement('canvas');
  sprite.width = sprite.height = size * SPRITE_SCALE;
  var ctx = sprite.getContext('2d');
  ctx.scale(SPRITE_SCALE, SPRITE_SCALE);
  ctx.translate(size / 2, size / 2);

  if (!f.crystal) {
    // brilho suave no tom da marca em volta (um contorno fino parecia bolinha vazada)
    ctx.shadowColor = edge;
    ctx.shadowBlur = f.r * 1.6 * SPRITE_SCALE;
    ctx.beginPath();
    ctx.arc(0, 0, f.r, 0, Math.PI * 2);
    ctx.fillStyle = white;
    ctx.fill();
  } else {
    ctx.lineCap = 'round';
    ctx.beginPath();
    for (var i = 0; i < 6; i++) {
      ctx.moveTo(0, 0);
      ctx.lineTo(0, -f.r);
      // raminhos
      ctx.moveTo(0, -f.r * 0.55);
      ctx.lineTo(f.r * 0.28, -f.r * 0.78);
      ctx.moveTo(0, -f.r * 0.55);
      ctx.lineTo(-f.r * 0.28, -f.r * 0.78);
      ctx.rotate(Math.PI / 3);
    }
    // contorno da marca por baixo, traço branco por cima
    ctx.lineWidth = 2.6;
    ctx.strokeStyle = edge;
    ctx.stroke();
    ctx.lineWidth = 1.2;
    ctx.strokeStyle = white;
    ctx.stroke();
  }
  f.size = size;
  return sprite;
}

function drawFlake(ctx, f, x, dt, rgb) {
  if (!f.sprite) f.sprite = flakeSprite(f, rgb);
  var half = f.size / 2;
  if (!f.crystal) {
    ctx.drawImage(f.sprite, x - half, f.y - half, f.size, f.size);
    return;
  }
  f.angle += f.spin * dt;
  ctx.save();
  ctx.translate(x, f.y);
  ctx.rotate(f.angle);
  ctx.drawImage(f.sprite, -half, -half, f.size, f.size);
  ctx.restore();
}

document.addEventListener('turbolinks:load', function() {
  if (snow) { snow(); snow = null; }
  if (!document.body.classList.contains('cda-season--christmas')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var rgb = brandRgb();
  var start = function() {
    if (snow || !document.body.classList.contains('cda-season--christmas')) return;
    // densidade pela área da tela, com teto (celular fica com uns 20 flocos, desktop com até 70)
    snow = startFallingLayer({
      density: 16000,
      max: 70,
      make: makeFlake,
      draw: function(ctx, f, x, dt) { drawFlake(ctx, f, x, dt, rgb); }
    });
  };
  // a neve é enfeite: só começa depois que a página carregou e o navegador ficou livre
  var idle = window.requestIdleCallback || function(callback) { return setTimeout(callback, 200); };
  if (document.readyState === 'complete') idle(start, { timeout: 1500 });
  else window.addEventListener('load', function() { idle(start, { timeout: 1500 }); }, { once: true });
});

// tira a neve antes de o Turbolinks guardar a página em cache (a volta cria de novo)
document.addEventListener('turbolinks:before-cache', function() {
  if (snow) { snow(); snow = null; }
});

// Luzinhas da faixa final do rodapé: a faixa abre com uma onda (layouts/newstyle/_footer), então
// o fio segue a beirada da onda e cada lâmpada é pendurada no ponto da curva embaixo dela.
// A curva é a borda de baixo do desenho da onda, no mesmo viewBox (1200 x 120, esticado).
var WAVE_EDGE = 'M0,27.35A600.21,600.21,0,0,0,321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3';
var SVG_NS = 'http://www.w3.org/2000/svg';
var waveEdge = null;

// altura da curva (no viewBox) para cada x, medida uma vez ao longo do caminho
function waveEdgeTable(path) {
  if (waveEdge) return waveEdge;
  var total = path.getTotalLength();
  waveEdge = [];
  for (var i = 0; i <= 240; i++) {
    var point = path.getPointAtLength(total * i / 240);
    waveEdge.push([point.x, point.y]);
  }
  return waveEdge;
}

function waveEdgeY(table, x) {
  for (var i = 1; i < table.length; i++) {
    if (table[i][0] >= x) {
      var a = table[i - 1];
      var b = table[i];
      return a[1] + (b[1] - a[1]) * ((x - a[0]) / ((b[0] - a[0]) || 1));
    }
  }
  return table[table.length - 1][1];
}

function hangFooterLights() {
  var lights = document.querySelector('.cda-season--christmas .cda-lights--footer');
  var wave = document.querySelector('.cda-footer-cta__wave svg');
  if (!lights || !wave) return;

  var width = lights.clientWidth;
  var height = wave.getBoundingClientRect().height;
  if (!width || !height) return;

  var wire = lights.querySelector('.cda-lights__wire');
  if (!wire) {
    wire = document.createElementNS(SVG_NS, 'svg');
    wire.setAttribute('class', 'cda-lights__wire');
    wire.setAttribute('viewBox', '0 0 1200 120');
    wire.setAttribute('preserveAspectRatio', 'none');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', WAVE_EDGE);
    wire.appendChild(path);
    lights.insertBefore(wire, lights.firstChild);
  }
  wire.style.height = height + 'px';
  lights.style.height = (height + 28) + 'px';

  var table = waveEdgeTable(wire.querySelector('path'));
  var bulbs = lights.querySelectorAll('.cda-lights__bulb');
  for (var i = 0; i < bulbs.length; i++) {
    var x = 22 + i * 44;
    if (x > width) {
      bulbs[i].style.display = 'none';
      continue;
    }
    var y = waveEdgeY(table, x * 1200 / width) * height / 120;
    bulbs[i].style.display = '';
    // o soquete (6px abaixo do topo da lâmpada) encosta no fio
    bulbs[i].style.transform = 'translate(' + (x - 22) + 'px,' + (y - 5).toFixed(1) + 'px)';
  }
  lights.classList.add('is-curved');
}

var hangFrame = null;
window.addEventListener('resize', function() {
  if (hangFrame) cancelAnimationFrame(hangFrame);
  hangFrame = requestAnimationFrame(hangFooterLights);
});
document.addEventListener('turbolinks:load', hangFooterLights);
